
import img0 from './Install_1.png';
import img1 from './Install_2.png';
import img2 from './Install_3.png';
import img3 from './Install_4.png';
import img4 from './Install_5.png';
import img5 from './Registration.png';
import img6 from './Organization_Clients.png';
import img7 from './SecureFile_Clients.png';
import img8 from './Add_Registration_Code.png';
import img9 from './Finish_Registration.png';
import img10 from './Login_Screen.png';
import img11 from './Default_Screen.png';
import img12 from './Protect_Files.png';
import img13 from './Encrypt_Files.png';
import img14 from './Files_Encrypted.png';
import img15 from './Encrypted_Files.png';
  
const content = `# OnData SecureFile Installation and Configuration Guide

## Objective

***
OnData SecureFile protects the unstructured data in all types of files and documents at all times. There is no limitation regarding the types of 
files. It can be Office documents, PDF, text files, video/audio files, industrial design files, or any types of files. Such files are strongly
encrypted at all times and dynamically made usable for authorized users only. The purpose of this guide is to detail the procedure to install and 
configure the OnData SecureFile product.
  
OnData SecureFile currently supports the Windows operating systems only, with other major operating systems, such as MacOS and Linux, on the product 
roadmap. Support for those operation systems will be announced as it is made available.  

***
  
## Install SecureFile
  
The OnData SecureFile release package comes with one installation file named \`SecureFileInstaller.exe\` for the Windows platform.
  
After obtaining the release package from OnData, you can extract it and run the \`SecureFileInstaller.exe\` inside to install the SecureFile product. 
Please note that administrative access to the operating system is required to install the OnData SecureFile product.  
  
Below is the list of steps to install the product on Windows.  
a. Ensure you have logged in with an administrative account to your computer and you do not have any other applications running.  
  
b. Double click on the \`SecureFileInstaller.exe\` after extracting the package. You will be prompted to allow the SecureFile installer to make 
changes to your system. Please note that the \`Verified publisher\` is \`OnData, Inc.\`  
  
![Confirmation Screen](${ img0 })  
  
c. Select \`Yes\` to continue. On the next screen select a folder where the application should be installed. It is recommended to use the default path.  
  
![Installation Folder](${ img1 })  

d. Click on \`Next\` and the following screen will be displayed. You have the option to create a desktop shortcut if preferred. Select \`Next\` to continue.  
  
![Desktop Shortcut](${ img2 })  
  
e. The following summary screen will be displayed before the installation actually starts. Select \`Install\` to proceed with the installation.  
  
![Summary Screen](${ img3 })  
  
f. The installation process will start and till completion. At the end of the installation, the following screen is displayed. Click on the 
\`Finish\` button to complete the installation process.     
  
![Finish Screen](${ img4 })  
  
**Note**: If your computer does not have the Microsoft Visual C++ 14 Runtime Libraries installed, it may automatically install the Visual C++ 14 
Runtime Libraries from Microsoft. If your computer does not have the Microsoft .NET Runtime 8.x installed, it may automatically install the 
Microsoft .NET Desktop Runtime 8.x component as well.   

g. The installer may or may not ask you for a system reboot. If a system reboot is required, please choose to reboot your system and proceed 
with the configuration process below.  
  
  
## Configure SecureFile
After the installation is completed, or after system reboot and login as an administrative user if a reboot is required, the OnData SecureFile 
application will be automatically started and show the registration screen, as illustrated below. Please **note** that a user with system admin 
access to the computer is required to login and complete the registration process.    

![SecureFile Registration](${ img5 })  

For one-time only, your computer will need to be registered with the OnData Platform. Below are the steps to complete the registration process. Please 
note a user with System Administrator or Security Administrator role to the OnData Portal is required to generate the registration code. If you are not 
a System Administrator or Security Administrator to the OnData Portal, please contact your system administrator and ask for a registration code.  

a. Login to the OnData Portal and navigate to the \`Clients\` tab under \`Organization Settings\`. 
  
![Organization Clients](${ img6 })  

b. Select on the \`Secure File App\` tab.  

![Organization SecureFile Clients](${ img7 })  

c. Click on the \`Registration Codes...\` button and click on the \`Add Registration Code\` button. Select the valid period of the registration code 
and how many times it can be used, and click on the \`Create\` button.

![Add Registration Code](${ img8 })  

d. Provide the newly created registration code to the user who needs to get his/her computer registered. The user can enter registration code to 
finish the registration process.  

![Finish Registration](${ img9 })  
  

## Use SecureFile
After the SecureFile application is registered, the user can login with his/her OnData account credentials. Please note that if your organization has 
configured Sign Sign-On (SSO) with your organization-wide identity provider, you will use the credentials from your identity provider. 
(For details on how to configure SSO with your organizational Identity Provider, please refer to 
the [**Azure AD integration**](../Portal_Configuration/Azure_Active_Directory_Integration.md) as an example.)   
  
![SecureFile Login](${ img10 })  
  
After login is successful, the default screen for the OnData SecureFile application is displayed. You can choose to close the default screen. Please 
note that when you close the default screen, the SecureFile application will continue to run in the system tray.  
  
![SecureFile Default Screen](${ img11 })  
  
To use SecureFile to protect files with sensitive data, in Windows explorer, you can right click on a file or folder, and select the option 
of \`Encrypt with OnData...\` from the context menu.  
  
![Protect Files](${ img12 })  
  
Depending on the number of files and file size, the OnData SecureFile may open up for you to proceed with the encryption process.  
  
![Encrypt Files](${ img13 })  
  
You can select the files to be encrypted and click on the \`Protect Files\` button. The selected files will be automatically encrypted.  
  
![Files Encrypted](${ img14 })  
  
After the files are encrypted, a file extension of \`.osf\` (acronym of OnData SecureFile) is appended to the file name and an OnData lock 
icon may appear on top of the file icons to indicate those files are protected by OnData SecureFile. Below is an example.  
  
![Encrypted Files](${ img15 })  
  
You can double click on those files to open, view, or edit them as usual. But behind the scenes, those files are strongly encrypted at all times.  
  
  `
  
export default content;
